// extracted by mini-css-extract-plugin
module.exports = {"container":"ticketsuccess_container__2NB4d","title":"ticketsuccess_title__3XMF2","image":"ticketsuccess_image__FBWu1","success":"ticketsuccess_success__1I3ON"};